/**
 * `/team/directory` route — gated on `employees:read:team` per be-063.
 * Renders the live <TeamDirectoryScreen> list view (Phase 08.2, D-16).
 */
import { createFileRoute } from "@tanstack/react-router";
import { requirePermission } from "@linkhr/auth";
import { TeamDirectoryScreen } from "../features/team/TeamDirectoryScreen.js";

export const Route = createFileRoute("/_auth/team/directory")({
  staticData: { breadcrumb: { labelKey: "team:nav.directory" } },
  beforeLoad: requirePermission({
    anyOf: ["employees:read:team"],
    defaultRoute: "/me/overview",
  }),
  component: TeamDirectoryScreen,
});
